// =====================================================
// 📁 QuotationProductAddButton.tsx
// =====================================================

import { Plus } from 'lucide-react';

interface Props {

  onClick?: () => void;

  fullWidth?: boolean;

  disabled?: boolean;

  size?: 'sm' | 'md';

  label?: string;

}

const QuotationProductAddButton = ({
  onClick,

  fullWidth = false,

  disabled = false,

  size = 'md',

  label = 'Agregar',
}: Props) => {

  // =====================================================
  // 🎨 Sizes
  // =====================================================
  const sizeStyles = {

    sm: `
      h-[38px]
      px-4
      text-sm
    `,

    md: `
      h-[42px]
      px-5
      text-sm
    `,

  };

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (

    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex
        items-center
        justify-center
        gap-2

        rounded-xl

        bg-primary

        font-medium
        text-white

        transition-all

        hover:bg-opacity-90

        disabled:cursor-not-allowed
        disabled:opacity-50

        ${sizeStyles[size]}

        ${fullWidth ? 'w-full' : ''}
      `}
    >

      <Plus className="h-4 w-4" />

      <span>
        {label}
      </span>

    </button>

  );

};

export default QuotationProductAddButton;